// extracted by mini-css-extract-plugin
module.exports = {"description":"Details_description__28yo4","edit-btn":"Details_edit-btn__3A7u2"};